/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FieldDefinitionValidation {
  limit?: number;
  allowedTypes?: Array<FieldDefinitionValidation.AllowedTypesEnum>;
}
export namespace FieldDefinitionValidation {
  export type AllowedTypesEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const AllowedTypesEnum = {
    USERNAME: 'USERNAME' as AllowedTypesEnum,
    FIRST_NAME: 'FIRST_NAME' as AllowedTypesEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as AllowedTypesEnum,
    LAST_NAME: 'LAST_NAME' as AllowedTypesEnum,
    NAME: 'NAME' as AllowedTypesEnum,
    AVATAR: 'AVATAR' as AllowedTypesEnum,
    GENDER: 'GENDER' as AllowedTypesEnum,
    BIRTHDAY: 'BIRTHDAY' as AllowedTypesEnum,
    FOUNDED: 'FOUNDED' as AllowedTypesEnum,
    DISSOLVED: 'DISSOLVED' as AllowedTypesEnum,
    DAY: 'DAY' as AllowedTypesEnum,
    MONTH: 'MONTH' as AllowedTypesEnum,
    YEAR: 'YEAR' as AllowedTypesEnum,
    EMAIL: 'EMAIL' as AllowedTypesEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as AllowedTypesEnum,
    PHONE: 'PHONE' as AllowedTypesEnum,
    FAX: 'FAX' as AllowedTypesEnum,
    WEBSITE: 'WEBSITE' as AllowedTypesEnum,
    BIC: 'BIC' as AllowedTypesEnum,
    JOB_TITLE: 'JOB_TITLE' as AllowedTypesEnum,
    INDUSTRY: 'INDUSTRY' as AllowedTypesEnum,
    GROUP: 'GROUP' as AllowedTypesEnum,
    REGION: 'REGION' as AllowedTypesEnum,
    ADDRESS: 'ADDRESS' as AllowedTypesEnum,
    STREET: 'STREET' as AllowedTypesEnum,
    COUNTRY: 'COUNTRY' as AllowedTypesEnum,
    BUILDING: 'BUILDING' as AllowedTypesEnum,
    BOX: 'BOX' as AllowedTypesEnum,
    LOCALITY: 'LOCALITY' as AllowedTypesEnum,
    NUMBER: 'NUMBER' as AllowedTypesEnum,
    ZIP: 'ZIP' as AllowedTypesEnum,
    DISTRICT: 'DISTRICT' as AllowedTypesEnum,
    PROVINCE: 'PROVINCE' as AllowedTypesEnum,
    SUBURB: 'SUBURB' as AllowedTypesEnum,
    STATE: 'STATE' as AllowedTypesEnum,
    COUNTY: 'COUNTY' as AllowedTypesEnum,
    LAT_LONG: 'LAT_LONG' as AllowedTypesEnum,
    FACEBOOK: 'FACEBOOK' as AllowedTypesEnum,
    YOUTUBE: 'YOUTUBE' as AllowedTypesEnum,
    INSTAGRAM: 'INSTAGRAM' as AllowedTypesEnum,
    WHATSAPP: 'WHATSAPP' as AllowedTypesEnum,
    WECHAT: 'WECHAT' as AllowedTypesEnum,
    TIKTOK: 'TIKTOK' as AllowedTypesEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as AllowedTypesEnum,
    TELEGRAM: 'TELEGRAM' as AllowedTypesEnum,
    SNAPCHAT: 'SNAPCHAT' as AllowedTypesEnum,
    PINTEREST: 'PINTEREST' as AllowedTypesEnum,
    TWITTER: 'TWITTER' as AllowedTypesEnum,
    REDDIT: 'REDDIT' as AllowedTypesEnum,
    LINKEDIN: 'LINKEDIN' as AllowedTypesEnum,
    VIMEO: 'VIMEO' as AllowedTypesEnum,
    DISCORD: 'DISCORD' as AllowedTypesEnum,
    TWITCH: 'TWITCH' as AllowedTypesEnum,
    TUMBLR: 'TUMBLR' as AllowedTypesEnum,
    MASTODON: 'MASTODON' as AllowedTypesEnum,
    PATREON: 'PATREON' as AllowedTypesEnum,
    KICKSTARTER: 'KICKSTARTER' as AllowedTypesEnum,
    INDIEGOGO: 'INDIEGOGO' as AllowedTypesEnum,
    GOFUNDME: 'GOFUNDME' as AllowedTypesEnum,
    TAKEAWAY: 'TAKEAWAY' as AllowedTypesEnum,
    UBEREATS: 'UBEREATS' as AllowedTypesEnum,
    DELIVEROO: 'DELIVEROO' as AllowedTypesEnum,
    SHIPTO: 'SHIPTO' as AllowedTypesEnum,
    WEIBO: 'WEIBO' as AllowedTypesEnum,
    QQ: 'QQ' as AllowedTypesEnum,
    KUAISHOU: 'KUAISHOU' as AllowedTypesEnum,
    QZONE: 'QZONE' as AllowedTypesEnum,
    SKYPE: 'SKYPE' as AllowedTypesEnum,
    NOTE: 'NOTE' as AllowedTypesEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as AllowedTypesEnum,
    LEGAL_NAME: 'LEGAL_NAME' as AllowedTypesEnum,
    LEGAL_FORM: 'LEGAL_FORM' as AllowedTypesEnum,
    LEGAL_ID: 'LEGAL_ID' as AllowedTypesEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as AllowedTypesEnum,
    JURISDICTION: 'JURISDICTION' as AllowedTypesEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as AllowedTypesEnum,
    PROPOSAL: 'PROPOSAL' as AllowedTypesEnum,
    CATEGORY: 'CATEGORY' as AllowedTypesEnum,
    OPENING_HOURS: 'OPENING_HOURS' as AllowedTypesEnum,
    CUSTOM: 'CUSTOM' as AllowedTypesEnum,
    FILE: 'FILE' as AllowedTypesEnum,
    IMAGE: 'IMAGE' as AllowedTypesEnum,
    FILE_KEY: 'FILE_KEY' as AllowedTypesEnum,
    FILE_NAME: 'FILE_NAME' as AllowedTypesEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as AllowedTypesEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as AllowedTypesEnum,
    DOCUMENT: 'DOCUMENT' as AllowedTypesEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as AllowedTypesEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as AllowedTypesEnum,
  };
}
